/** @jsxImportSource @emotion/react */
import React from 'react'

interface HomeIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: number
  color?: string
}

const HomeIcon: React.FC<HomeIconProps> = ({
  size,
  color,
  className,
  style,
  ...rest
}) => {
  return (
    <span className={`anticon ${className || ''}`} style={style} {...rest}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size ? `${size}px` : '1em'}
        height={size ? `${size}px` : '1em'}
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          d='M12 6.19L17 10.69V18.5H15V12.5H9V18.5H7V10.69L12 6.19ZM12 3.5L2 12.5H5V20.5H11V14.5H13V20.5H19V12.5H22L12 3.5Z'
          fill={color || 'currentColor'}
        />
      </svg>
    </span>
  )
}

export default HomeIcon
